import { useEffect, useState } from "react";
import "../../css/style.css";
import { Button, CircularProgress } from "@material-ui/core";
import i18next from "i18next";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { userService } from "../../_services";
import MeetingSlots from "./MeetingSlots";
import MeetingRooms from "./MeetingRooms";
import { showGlobalSnackbar } from "../../_services/snackbarService";
import "./meeting.css";

export default function MeetingDialog({ open, closeDialog, userTo, conferenceId }) {
    const [slots, setSlots] = useState({});
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (open) {
            setIsLoading(true)
            userService.getWrapper(
                `api/meeting/dialog/${conferenceId}?user_to=${userTo}`,
                data => {
                    refreshSlots(data.data);
                    setIsLoading(false);
                },
                (error) => {
                    setIsLoading(false);
                    if (error !== "") {
                        console.log(error);
                    }
                }
            );
        }
    }, [userTo, conferenceId, open]);

    const setSelectedSlot = (day, slotTime) => {
        setSelectedRoom(null);
        setSelectedDay(day);
        setSelectedTime(slotTime);
    }

    const refreshSlots = data => {
        setSelectedDay(null);
        setSelectedTime(null);
        setSelectedRoom(null);
        setSlots(data);
    }

    const sendRequest = () => {
        let url = `api/meeting/dialog/${conferenceId}?user_to=${userTo}&start=${selectedDay} ${selectedTime}`;
        if (selectedRoom.length > 0) {
            url += "&room=" + selectedRoom;
        }
        userService.postWrapper(
            url,
            {},
            function (data) {
                showGlobalSnackbar(data.data);
                closeDialog();
            },
            function (error) {
                if (error.response.status == 409) {
                    refreshSlots(error.response.data);
                }
            }
        );
    }

    return (
        <Dialog open={open}>
            <DialogTitle>{i18next.t("meeting_slot")}</DialogTitle>
            <DialogContent>
                {isLoading 
                    ? <div className="shadow">
                        <div className="shadow_circle">
                            <CircularProgress />
                        </div>
                    </div> 
                    : <MeetingSlots slots={slots} selectedDay={selectedDay} selectedTime={selectedTime} setSelectedSlot={setSelectedSlot} />
                }
                {selectedDay && selectedTime &&
                    <MeetingRooms rooms={slots[selectedDay][selectedTime]} selectedRoom={selectedRoom} setSelectedRoom={setSelectedRoom} />
                }
            </DialogContent>
            <DialogActions>
                {selectedDay && selectedTime && (selectedRoom !== null) && <Button onClick={sendRequest}>{i18next.t("meeting_send")}</Button>}
                <Button onClick={closeDialog}>
                    {i18next.t("btn_cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
